import { RouteRecordRaw } from 'vue-router'

const GymPlans = () =>
  import(/* webpackChunkName: "gym-plans-view" */ './pages/plans/index.vue')

const GymMembers = () =>
  import(/* webpackChunkName: "gym-members-view" */ './pages/members/index.vue')

const GymSubscriptions = () =>
  import(
    /* webpackChunkName: "gym-subscriptions-view" */ './pages/subscriptions/index.vue'
  )

const GymPayments = () =>
  import(
    /* webpackChunkName: "gym-payments-view" */ './pages/payments/index.vue'
  )

const GymAccess = () =>
  import(/* webpackChunkName: "gym-access-view" */ './pages/access/index.vue')

const GymAccessHistory = () =>
  import(
    /* webpackChunkName: "gym-access-history-view" */ './pages/access-history/index.vue'
  )

export const moduleRoutes: Array<RouteRecordRaw> = [
  {
    path: 'gimnasio',
    redirect: { name: 'gym-plans' },
  },
  {
    path: 'gimnasio/planes',
    name: 'gym-plans',
    component: GymPlans,
    meta: {
      title: 'Planes',
      auth: {
        requiredPermission: 'gym.plans.view',
        requiredModule: 'gym',
        redirect: '/auth/login',
        forbiddenRedirect: '/inicio',
      },
    },
  },
  {
    path: 'gimnasio/socios',
    name: 'gym-members',
    component: GymMembers,
    meta: {
      title: 'Socios',
      auth: {
        requiredPermission: 'gym.members.view',
        requiredModule: 'gym',
        redirect: '/auth/login',
        forbiddenRedirect: '/inicio',
      },
    },
  },
  {
    path: 'gimnasio/suscripciones',
    name: 'gym-subscriptions',
    component: GymSubscriptions,
    meta: {
      title: 'Suscripciones',
      auth: {
        requiredPermission: 'gym.subscriptions.view',
        requiredModule: 'gym',
        redirect: '/auth/login',
        forbiddenRedirect: '/inicio',
      },
    },
  },
  {
    path: 'gimnasio/cobros',
    name: 'gym-payments',
    component: GymPayments,
    meta: {
      title: 'Cobros',
      auth: {
        requiredPermission: 'gym.payments.view',
        requiredModule: 'gym',
        redirect: '/auth/login',
        forbiddenRedirect: '/inicio',
      },
    },
  },
  {
    path: 'gimnasio/accesos',
    name: 'gym-access-history',
    component: GymAccessHistory,
    meta: {
      title: 'Accesos',
      auth: {
        requiredPermission: 'gym.access.view',
        requiredModule: 'gym',
        redirect: '/auth/login',
        forbiddenRedirect: '/inicio',
      },
    },
  },
  {
    path: 'gimnasio/acceso',
    name: 'gym-access',
    component: GymAccess,
    meta: {
      title: 'Acceso',
      kiosk: true,
      auth: {
        requiredPermission: 'gym.kiosk.operate',
        requiredModule: 'gym',
        redirect: '/auth/login',
        forbiddenRedirect: '/inicio',
      },
    },
  },
]
